import { parseAgreementToThemeClub } from '@partiu/api/club/utils';
import { IAgreement } from '@partiu/api/dashboard/types';
import { getLanding } from '@partiu/api/landing/api';
import { snakeCaseDictToCamelCaseDict } from '@partiu/api/utils';

export async function themeResolver() {
  let slug;
  if (window.location.hostname.includes('partiu.com.br')) {
    slug = window.location.hostname.split('.')[0];
  } else {
    slug = window.location.hostname;
  }

  if (slug === 'viuvantagens') slug = 'viu';
  else if (slug === 'localhost' || slug === 'b28') slug = 'grajavantagens';

  try {
    const response = await getLanding(slug);
    return parseAgreementToThemeClub(snakeCaseDictToCamelCaseDict(response.data) as IAgreement);
  } catch (error) {
    return null; // or handle the error as needed
  }
}
